import script from "./PropertyGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyGallery.vue?vue&type=script&setup=true&lang=js"

import "./PropertyGallery.vue?vue&type=style&index=0&id=6da195e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6da195e6"]])

export default __exports__